module.exports = __webpack_public_path__ + "static/media/web.2b1f5975.png";